export default {
  10001: '请输入用户名或邮箱',
  10002: '邮箱输入有误',
  10003: '用户名输入有误',
  10004: '密码输入有误',
  10005: '用户状态异常',
  10006: '用户名已存在',
  10007: '手机号已存在',
  10008: '用户状态有误',
  10009: '未找到对应用户',
  10010: '智能交易产品不正确',
  10011: '用户余额不足，请充值或释放保证金后进行购买',
  10012: '未找到对应天数',
  10013: '投资金额有误',
  10014: '量化交割产品不正确',
  10015: '当前未在可交易时间',
  10016: '购买金额不正确',
  10017: '未找到对应期限',
  10018: '获取系统参数失败',
  10019: '该用户当前认证状态不正确',
  10020: '藏品状态不正确',
  10021: '未填写接收地址',
  10022: '用户未实名认证',
  10023: '贷款期限设置有误',
  10024: '贷款金额超出范围',
  10025: '已购买相同产品，请勿重复购买',
  10026: '请选择提款方式',
  10027: '贷款金额不能为空',
  10028: '贷款期限不能为空',
  10029: '贷款金额必须大于0',
  10030: '贷款期限配置不存在',
  10031: '贷款金额低于最小值',
  10032: '贷款金额超过最大值',
  10033: '贷款记录ID不能为空',
  10034: '贷款记录不存在',
  10035: '无权限操作此贷款记录',
  10036: '贷款状态不允许还款',
  10037: '账户余额不足',
  10038: '还款申请正在审核中，请勿重复申请',
  10039: '还款申请提交失败',
  10040: '还款申请失败',
  10088: '邮箱参数错误，请检查后重新输入',
  10089: '验证码已发送，请勿重复请求',
  10090: '验证码已过期，请重新发送',
  10091: '手机验证码错误',
  10092: '该邮箱已被注册',
  10093: '钱包地址不能为空',
  10094: 'VIP等级不足，需要{level}及以上等级',
  10095: '投资金额超过最高限额',
  10096: 'Nonce 无效或已过期，请重新获取',
  10097: '签名消息不能为空',
  10098: '签名消息中的 Nonce 不匹配',
  10099: '签名消息中的地址不匹配',
  10100: '签名验证失败，请重试',
  10101: '签名地址不匹配',
  10102: '获取订单数据失败',
  10103: '订单不存在',
  10104: '无权访问此订单',
  10105: '获取当前价格失败',
  10106: '订单状态不允许平仓',
  10107: '现货交易不支持卖空，请先买入持仓后再卖出',
  10108: '美股当前不在交易时段（美东周一至周五 9:30-16:00），请稍后再试',
  10109: '外汇/贵金属当前不在交易时段（美东周日17:00至周五17:00），请稍后再试',
  10110: '交易数量无效，请输入大于0的数量',
  20001: '提交审核成功',
  20002: '充值添加成功，已提交审核',
  20003: '提现添加成功，已提交审核',
  20004: '购买成功',
  20005: '操作成功',
  20006: '该邮箱已被注册',
  20007: '谷歌登录失败，请重试',
  20024: '已购买相同产品，请勿重复购买',
  20094: '超出提款限额，每人每天限提一次',
  20095: '提款正在审核中，请勿重复操作',
  20096: '购买失败（限制2次）',
  20097: '购买失败（限制3次）',
  20098: '每位用户的购买订单数量限制为: 3',
  20099: '每位用户的购买订单数量限制为: 2',
  20100: '每位用户的购买订单数量限制为: 1',
  20101: '当前产品的自动交易引擎尚未开启',
  20102: '您的账号已被冻结，暂无法进行交易与提现。如有疑问请联系客服。',
  20103: '登录状态已失效，请重新登录',
  20104: '用户未登录，请先登录',
  20105: '请输入提现PIN码',
  20106: '提现PIN码错误',
  20107: '请输入提现PIN码',
  20108: '请输入有效的PIN码',
  20109: '两次输入的PIN码不一致',
  20110: 'PIN码设置成功',
  20111: 'PIN码设置失败',
  20112: '请先设置提现PIN码',
  20115: '请输入原提现PIN码',
  20116: '原提现PIN码错误',
  20117: '新PIN码不能与原PIN码相同',
  20118: '已设置提现PIN码，请使用修改功能',
  20119: '提现PIN码修改成功',
  Invite: {
    CopyLink: '复制链接',
    FillInAccount: '填写在线表格并开设交易账户',
    Fund: '资金',
    FundYourPrefer: '通过您喜欢的任何资金方式为您的账户充值',
    InviteFriends: '邀请朋友',
    InviteYourFriends: '邀请您的朋友',
    Register: '注册',
    StartTradingPlatform: '开始使用我们屡获殊荣的交易平台进行交易',
    Trade: '交易',
    WhenYourRewards: '邀请您的亲朋好友加入我们，一起收获丰厚的回报，踏上致富之路！',
  },
  Market: {
    CreateAPlanToTrade: '创建交易计划',
    ETF: '贵金属',
    ExpectedReturn: '预期利润',
    LastPrice: '最新价格',
    Lots: '手',
    OpenPrice: '开仓价格',
    OrderAgain: '再次下单',
    OrderNumber: '订单号',
    Price: '价格',
    Prices: '价格',
    Sizes: '数量...',
    SpotPrice: '价格',
    StopLossPrices: '止损价格...',
    TakeProfitPrices: '止盈价格...',
    WantMoreStableEarning: '想要更稳定的收益',
    WhatIsSmartTrading: '什么是智能交易',
    available: '可用',
    buy: '买多',
    buyLong: '买/买多',
    buyLongBtn: '买多',
    chart: '图表',
    checkoutSuccess: '结算成功',
    close: '收盘价',
    confirm: '确认',
    contracts: '现货',
    create: '创建',
    cypto: '加密货币',
    day: '天',
    down: '跌',
    estimation: '预期利润',
    forex: '外汇',
    free: '交易费',
    frees: '交易费',
    futures: '大宗',
    high: '最高价',
    hour: '小时',
    investment: '投资金额',
    leverage: '杠杆',
    limit: '限价',
    low: '最低价',
    market: '市价',
    min: '分钟',
    mon: '月',
    name: '名称',
    notOpen: '功能暂未开放',
    open: '开盘价',
    options: '量化交割',
    optionsTime: '量化交割时间',
    orderConfirm: '订单确认',
    quantity: '数量',
    requiredAmount: '应付金额',
    requiredMargin: '应付金额',
    return: '收益',
    sell: '卖空',
    sellShort: '卖/卖空',
    sellShortBtn: '卖空',
    spot: '现货',
    spotBuy: '买入',
    spotSell: '卖出',
    stocks: '股票',
    stopLoss: '止损',
    stopLossPrice: '止损价格',
    takeProfit: '止盈',
    takeProfitPrice: '止盈价格',
    time: '时间',
    up: '涨',
    volume: '成交量',
    watchlist: '收藏',
    watchlistAdded: '已加入收藏',
    watchlistRemoved: '已取消收藏',
    week: '周',
  },
  SmartTrading: {
    InterInvestmentAmount: '投资金额...',
    SelectATimeframe: '选择一个时间周期',
    amount: '金额',
    create: '创建',
    createAPlan: '创建计划',
    cycle: '周期',
    dailyRor: '日收益率',
    dailyYield: '日收益',
    days: '天',
    daysUnit: '天',
    expirationTime: '到期时间',
    investment: '金额',
    investmentRange: '资金限额',
    product: '产品',
    runTime: '运行时间',
    smartTradingClose: '已关闭',
    smartTradingRunning: '正在进行',
    smrtTrading: '智能交易',
    startTime: '开始时间',
    status: '状态',
    timeframe: '时间周期',
    todaysEarnings: '今日收益',
    totalRevenue: '总收益',
    transaction: '交易品种',
  },
  about: {
    aboutUs: '关于我们',
  },
  aboutUs: {
    about: '关于我们',
    subtitle1: '公司简介',
    subtitle2: '合作伙伴',
    title: '关于{title}',
  },
  account: {
    BTCAmount: '金额',
    LOTS: '手',
    LastDigits: '最后6位数字',
    Lots: '手',
    PaymentAmount: '支付金额',
    PleaseUploadSubmission: '请上传加密货币支付截图，并在提交等待验证',
    Preview: '预览',
    SelectImage: '选择图片',
    Supports: '支持格式：JPG、JPEG2000、PNG',
    TransactionHash: '交易哈希',
    UploadProof: '上传证明',
    UploadYourScreenshot: '上传您的转账截图',
    WithdrawalPIN: '提现PIN码',
    accountVerification: '账户验证',
    address: '地址',
    allOrders: '全部订单',
    amount: '金额',
    approved: '批准日期',
    balance: '余额',
    buy: '买多',
    cancel: '取消',
    changeLanguage: '更改语言',
    changePassword: '更改密码',
    close: '平仓',
    closePrice: '平仓价格',
    closeTime: '平仓时间',
    closed: '已关闭',
    completed: '已完成',
    confirmWithdrawalPIN: '确认提现PIN码',
    contactUs: '联系我们',
    copyAddress: '复制地址',
    copySuccess: '复制成功',
    createTime: '创建时间',
    currentEarnings: '当前收益',
    cycle: '周期',
    dailyRate: '日利率',
    dailyRor: '日收益率',
    days: '天',
    demo: '演示账户',
    deposit: '存款',
    depositWithdraw: '存款和提款',
    down: '跌',
    downloadPDF: '下载贷款协议',
    earlyExist: '终止交易',
    earlyExit: '终止交易',
    earlyExitTip: '如果提前终止交易，系统将自动扣除本金的{num}作为违约金，您的总收入将被扣除',
    earnedDays: '已收益天数',
    earning: '收益中',
    enterWithdrawalPIN: '输入提现PIN码',
    expandMore: '展开更多',
    expirationTime: '到期时间',
    failed: '失败',
    financial: '理财',
    freeMargin: '占用保证金',
    futures: '现货',
    helpCenter: '常见问题',
    holding: '持仓中',
    investmentAmount: '投资金额',
    investmentPeriod: '投资期限',
    investmentTime: '投资时间',
    inviteFriends: '邀请好友',
    lastPrice: '最新价格',
    lever: '杠杆',
    liquidatedDamages: '违约金',
    loan: '贷款',
    logOut: '退出登录',
    logoutConfirm: '确定要退出登录吗？',
    margin: '预期利润',
    maturityTime: '到期时间',
    myAccount: '我的账户',
    newWithdrawalPIN: '新提现PIN码',
    noSpotPosition: '当前无现货持仓可卖出',
    notification: '通知',
    notifications: '通知',
    okay: '好的',
    oldWithdrawalPIN: '原提现PIN码',
    open: '开仓价格',
    openPrice: '开仓价格',
    openShort: '开仓',
    openTime: '开仓时间',
    options: '量化交割',
    optionsOrder: '量化交割订单',
    order: '订单',
    pending: '待处理',
    pips: '点数',
    productName: '产品名称',
    profit: '利润',
    profitRate: '收益率',
    putAway: '收起',
    receiveAddress: '接收地址',
    recreatePlan: '继续创建计划',
    refund: '退款',
    refundTip: '资金将退还至您的现金账户，请查收。',
    repayNow: '立即还款',
    repaySuccess: '还款成功',
    repayment: '还款',
    repaymentAmount: '还款金额',
    repaymentDate: '还款日期',
    repeatOrder: '继续开仓',
    reviewed: '待审核',
    runTime: '运行时间',
    save: '保存',
    sell: '卖空',
    setWithdrawalPIN: '设置提现PIN码',
    settings: '设置',
    settled: '已结算',
    smart: '智能交易',
    spot: '现货',
    spotBuy: '买入',
    spotClose: '卖出平仓',
    spotSell: '卖出',
    startTime: '开始时间',
    staticincome: '钱包收益',
    status: '状态',
    success: '成功',
    time: '时间',
    todayEarnings: '今日收益',
    todayProfit: '今日收益',
    tokenType: '代币类型',
    totalInterest: '总利息',
    totalProfit: '总利润',
    totalRepayment: '还款总额',
    totalRevenue: '总收益',
    transFees: '交易费用',
    transRecord: '交易记录',
    transaction: '交易',
    type: '类型',
    up: '涨',
    withdraw: '取款',
    withdrawNow: '立即取款',
    withdrawalPINBound: '已设置提现PIN码',
    withdrawalPINNotSet: '未设置',
    withdrawalPINRequired: '此次交易需要输入提现PIN码',
  },
  amount: '金额',
  bangZhuZhongXin: '帮助中心',
  biaoDian: '标点',
  board: {
    content: '本软件以最佳技术专业满足您的所有需求',
    continue: '继续',
    skip: '跳过',
    title: '最佳交易平台',
  },
  bread: {
    introduction: '简介',
  },
  chaKan: '查看',
  chongZhi: '充值',
  chongZhiJinexiaoYuZuiDiChongZhiJinE: '充值金额小于最低充值金额',
  chongZhiPingZheng: '充值凭证',
  chongZhiShiJian: '充值时间',
  chongZhiShuoMing: '充值说明：',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    '充值说明：USDT最低充值金额为120，BTC最低充值金额为0.015，ETH最低充值金额为0.2',
  close: '关闭',
  common: {
    loadMore: '加载更多',
  },
  'customerService.error': '客服系统异常，请稍后再试。',
  'customerService.close': '关闭',
  'customerService.connected': '已连接',
  'customerService.imageAlt': '客服图片',
  'customerService.imagePreview': '图片预览',
  'customerService.imageTooLarge': '图片不能超过 5MB',
  'customerService.imageTypeUnsupported': '仅支持 PNG、JPEG 或 WebP 图片',
  'customerService.imageUnavailable': '图片已失效',
  'customerService.loadFailed': '在线客服暂时无法加载，请稍后再试。',
  'customerService.loading': '加载中…',
  'customerService.loginRequired': '请先登录后再联系客服',
  'customerService.openImage': '查看原图',
  'customerService.placeholder': '输入消息，Enter 发送',
  'customerService.send': '发送',
  'customerService.sendImage': '发送图片',
  'customerService.reconnecting': '正在重连',
  'customerService.title': '在线客服',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    '大多数网站都会采取措施保护用户的个人信息，例如使用加密技术来保护密码。',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    '大多数网站都允许用户更改他们的个人信息，例如更改电子邮件地址或密码。 但是，某些信息可能无法更改，例如用户名。',
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    '贷款后{num}天内无需支付利息，{num}天后需支付利息。',
  daiShenHe: '待审核',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    '但是，如果您使用的网站或应用程序存在安全漏洞，您的个人信息可能会被泄露。',
  dangQiLiRun: '当期利润',
  dangQianLiXi: '当前利息',
  daoQiHuanXiHuanBen: '到期还息还本',
  daoQiShiJian: '到期时间',
  demo_mode: '演示模式，不允许操作',
  dengLuChengGong: '登录成功',
  di: '低',
  dianHuaHaoMa: '电话号码：',
  dieJiaLiShuai: '叠加利率:',
  el: {
    cascader: {
      loading: '加载中',
      noData: '暂无数据',
      noMatch: '无匹配数据',
      placeholder: '请选择',
    },
    colorpicker: {
      clear: '清空',
      confirm: '确定',
    },
    datepicker: {
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      endDate: '结束日期',
      endTime: '结束时间',
      month1: '1 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      months: {
        apr: '四月',
        aug: '八月',
        dec: '十二月',
        feb: '二月',
        jan: '一月',
        jul: '七月',
        jun: '六月',
        mar: '三月',
        may: '五月',
        nov: '十一月',
        oct: '十月',
        sep: '九月',
      },
      nextMonth: '下个月',
      nextYear: '后一年',
      now: '此刻',
      prevMonth: '上个月',
      prevYear: '前一年',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      today: '今天',
      weeks: {
        fri: '五',
        mon: '一',
        sat: '六',
        sun: '日',
        thu: '四',
        tue: '二',
        wed: '三',
      },
      year: '年',
    },
    empty: {
      description: '暂无数据',
    },
    image: {
      error: '加载失败',
    },
    messagebox: {
      cancel: '取消',
      confirm: '确定',
      error: '输入的数据不合法!',
      title: '提示',
    },
    pageHeader: {
      title: '返回',
    },
    pagination: {
      goto: '前往',
      pageClassifier: '页',
      pagesize: '条/页',
      total: '共 {total} 条',
    },
    popconfirm: {
      cancelButtonText: '取消',
      confirmButtonText: '确定',
    },
    select: {
      loading: '加载中',
      noData: '无数据',
      noMatch: '无匹配数据',
      placeholder: '请选择',
    },
    table: {
      clearFilter: '全部',
      confirmFilter: '筛选',
      emptyText: '暂无数据',
      resetFilter: '重置',
      sumText: '合计',
    },
    transfer: {
      filterPlaceholder: '请输入搜索内容',
      hasCheckedFormat: '已选 {checked}/{total} 项',
      noCheckedFormat: '共 {total} 项',
      noData: '无数据',
      noMatch: '无匹配数据',
      titles: ['列表 1', '列表 2'],
    },
    tree: {
      emptyText: '暂无数据',
    },
    upload: {
      continue: '继续上传',
      delete: '删除',
      deleteTip: '按 delete 键可删除',
      preview: '查看图片',
    },
  },
  financial: {
    amountOutOfRange: '投资金额超出范围',
    confirmInvestment: '确认投资',
    dailyRate: '日利率',
    days: '天',
    earning: '收益中',
    expectedReturn: '预期收益',
    insufficientBalance: '余额不足',
    investNow: '立即投资',
    investmentAmount: '投资金额',
    investmentPeriod: '投资期限',
    investmentSuccess: '投资成功',
    maxAmount: '最大投资',
    minAmount: '最小投资',
    myInvestments: '我的投资',
    pleaseEnterAmount: '请输入投资金额',
    productList: '产品列表',
    settled: '已结算',
    status: '状态',
    title: '理财产品',
    totalInvestment: '总投资',
    totalReturn: '总收益',
  },
  gao: '高',
  gouMai: '购买',
  gouMaiChengGong: '购买成功',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei: '国际货币账户联系在线支持服务进行匹配',
  home: {
    Application: '应用',
    AvailableOnThe: 'Available on the',
    CreditCard: '加密',
    CreditCardInfo: '通过使用加密货币进行存款，可以获得额外的安全层，并确保快速交易处理。',
    CryptocurrenciesListed: '上市加密货币',
    GetStarted: '开始',
    NewFeaturesInOnline: '在线新功能',
    NewFeaturesInOnlineInfo: '了解这个完整平台的精彩功能',
    RegisteredUsers: '注册用户',
    allChains: '全部链',
    announcementClose: '关闭公告',
    announcementLabel: '公告',
    announcementView: '查看详情',
    announcementAmount: '借出金额',
    announcementAnnualRate: '年化收益率',
    announcementBelowMinimum: '低于 {amount} USDT',
    announcementCompoundInterest: '复利',
    announcementCurrentConfig: '当前配置',
    announcementEarningMode: '计息方式',
    announcementRateNotice: '收益按后台当前档位规则计算；实际金额以用户资产页和结算记录为准。',
    announcementRatesLoading: '正在读取当前收益档位…',
    announcementSettlement: '每日结算时点',
    announcementSimpleInterest: '单利',
    announcementYieldEyebrow: '收益说明',
    announcementYieldIntro:
      '借出金额越高，适用的年化收益率越高；低于首档金额仍可参与，但不产生利息。',
    announcementYieldTitle: '当前收益明细',
    appLicationInfo: '摒弃传统规则的移动银行，为您提供精确的财务管理工具。',
    billion: 'B',
    billionInfo: '平均24小时交易量',
    button1Title: '最低交易费用',
    button1Title1: '在一个地方交易所有资产',
    button1Title2: '外汇、加密货币、股票、ETF、期货',
    button2Title: '低利率和更高额度',
    button2Title1: '投资借款',
    button2Title2: '无需抵押品，轻松借款，享受财富增值机会！',
    button3Title: '简单稳定',
    button3Title1: '智能交易',
    button3Title2: '一键创建您的盈利计划',
    button4Title: '帮助世界各地的儿童',
    button4Title1: 'NFT慈善',
    button4Title2: '购买NFT艺术品以支持联合国儿童基金会',
    closeFeatured: '关闭推荐',
    colApy: 'APY',
    colAsset: '资产',
    colChain: '所属链',
    colTotalDeposits: '总存款',
    depositAction: 'Deposit',
    depositSubtitle: '借贷池提供流动性以赚取利息',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: '筛选资产...',
    homeTitle: '在最佳平台上购买、交易和持有350多种加密货币。',
    loading: '加载中...',
    million: 'M',
    noMore: '没有更多了',
    noPools: '暂无借贷池数据',
    noticeInfo: '钱包可以将BTC兑换为USD',
    noticeInfo1: '用模拟账户操作',
    onlineSupport: '在线客服',
    period: '周期',
    periodDaySuffix: '天',
    periodDays: '{count}天',
    poolCount: '共 {count} 个池',
    sortApy: '排序：APY',
    sortTotalDeposits: '排序：总存款',
    totalPool: '总借贷池',
    totalYieldRate: '收益率',
  },
  huanKuanZhong: '还款中',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    '欢迎使用我们屡获殊荣的金融交易平台，与全球投资者一起探索未来的金融世界！',
  jiXiShiJian: '计息时间',
  jiXuTouZi: '继续投资',
  jiangTuPianTuoFangDaoCiChuHuo: '将图片拖放到此处, 或',
  jieZhiShiJian: '截止时间',
  jiuMiMa: '旧密码',
  juJueYuanYin: '拒绝原因',
  kai: '开',
  lendingAssets: {
    addAsset: '新增授权币种',
    authorizedBalance: '授权资产余额',
    availableAmount: '可提现金额',
    dailyOrders: '每日结算订单',
    dailyProfit: '每日收益',
    estimated24hEarnings: '预计24小时收益',
    estimated24hHint: '基于当前授权余额与档位利率估算的明日收益',
    joinPool: '加入借贷池',
    loadMore: '加载更多',
    needAuth: '加入借贷池后即可查看资产余额与收益',
    needLogin: '请先登录后查看资产',
    noOrders: '暂无结算订单',
    pageDesc: '查看授权资产余额、借贷池收益与每日结算订单',
    poolEarnings: '借贷池收益',
    todayEarnings: '今日收益',
    totalEarnings: '累计收益',
    withdraw: '提现',
    withdrawRecords: '提现记录',
    withdrawnAmount: '已提现金额',
    walletBalances: '钱包资产余额',
  },
  lendingContent: {
    rulesSecurity:
      '<p>本页说明借贷池<strong>计息规则、结算周期与安全机制</strong>。参与前请仔细阅读并确保理解相关风险。</p>\n\n<h2>一、计息规则</h2>\n<h3>1.1 计息基数</h3>\n<p>收益以用户<strong>链上授权（Approve）后的可用余额</strong>为计息基数。授权成功后，系统读取钱包中 USDT / USDC 等支持资产的授权额度与余额，作为每周期结算的参考本金。</p>\n\n<h3>1.2 计息利率</h3>\n<p>结算利率参考用户所关联借贷池的<strong>Supply APY（存款年化收益率）</strong>，并随链上市场数据同步更新。APY 由基础利率与奖励利率组成，实际结算以当周期生效费率为准。</p>\n\n<h3>1.3 结算周期</h3>\n<ul>\n  <li><strong>结算频率：</strong>每日生成一次收益结算订单；</li>\n  <li><strong>订单类型：</strong>日收益（可在「个人资产 → 结算订单」中查看）；</li>\n  <li><strong>展示字段：</strong>结算金额、币种类型（USDT / USDC）、结算时间。</li>\n</ul>\n<p>单次结算金额 ≈ 授权余额 × 当期 APY ÷ 365（即按日折算）。极小金额可能因精度规则显示为 0。</p>\n\n<h3>1.4 累计与今日收益</h3>\n<p>「个人资产」页展示<strong>累计收益</strong>（历史结算总和）与<strong>今日收益</strong>（当日 0:00 至当前已结算部分）。数据以系统订单记录为准。</p>\n\n<h2>二、授权与安全</h2>\n<h3>2.1 非托管原则</h3>\n<p>本服务采用<strong>非托管</strong>模式：平台不保管用户私钥、助记词或可直接动用资金的密码。所有链上授权操作须由用户在自有钱包中确认签名。</p>\n\n<h3>2.2 授权范围</h3>\n<p>加入借贷池时，用户需对指定 ERC-20 代币执行 <strong>Approve（授权）</strong>，允许协议合约在授权额度内读取或转移代币。用户应：</p>\n<ul>\n  <li>仅对官方界面发起的授权请求进行确认；</li>\n  <li>定期在钱包中检查并撤销不再使用的授权；</li>\n  <li>切勿向未知地址或钓鱼网站授权。</li>\n</ul>\n\n<h3>2.3 账户与接口安全</h3>\n<ul>\n  <li>客户端接口采用 Token 鉴权，敏感操作需有效登录态；</li>\n  <li>全站 HTTPS 加密传输；</li>\n  <li>授权记录与结算订单留痕，支持事后查询。</li>\n</ul>\n\n<h2>三、链上协议安全</h2>\n<ul>\n  <li>底层借贷协议基于经审计的开源智能合约，存款、借款、清算逻辑链上执行；</li>\n  <li>超额抵押与清算机制用于维持系统偿付能力；</li>\n  <li>池子 TVL、APY、利用率等数据来自公开数据源，与链上状态可能存在分钟级延迟。</li>\n</ul>\n\n<h2>四、用户须知</h2>\n<ul>\n  <li>DeFi 收益随市场波动，<strong>不保证固定收益</strong>；</li>\n  <li>稳定币在极端行情下可能出现脱锚风险；</li>\n  <li>网络拥堵可能导致授权或查询延迟；</li>\n  <li>请勿泄露私钥、助记词或验证码；</li>\n  <li>如遇可疑链接或异常授权请求，请立即停止操作并联系在线支持。</li>\n</ul>\n\n<h2>五、撤销与退出</h2>\n<p>用户可随时在钱包中将代币授权额度设为 0 以<strong>撤销 Approve</strong>。撤销后不再产生新的周期收益，历史已结算订单仍可查询。撤销授权不影响链上已有资产所有权，资产仍由用户钱包地址持有。</p>\n\n<p>— 规则如有调整，以客户端最新展示及结算订单记录为准。</p>',
    whitepaper:
      '<p><strong>文档版本：</strong>V3.28 &nbsp;|&nbsp; <strong>发布日期：</strong>2022 年 &nbsp;|&nbsp; <strong>文档性质：</strong>产品白皮书与安全评估摘要</p>\n\n<h2>一、摘要</h2>\n<p>本借贷池（Lending Pool）是基于去中心化金融（DeFi）货币市场协议构建的链上流动性存贷服务模块。系统通过开源智能合约与程序化利率模型，将用户的数字资产接入成熟的链上借贷市场，实现<strong>存款生息、抵押借款、流动性共享</strong>等核心功能。</p>\n<p>本模块不依赖人工干预进行日常资金调度，利率、容量、利用率等关键指标均由链上市场实时决定，并通过多源数据聚合与定时同步机制向用户透明展示。本文档旨在说明产品架构、运行机制、安全设计、风险披露及合规评估结论，供用户与合作伙伴查阅。</p>\n\n<h2>二、行业背景与产品定位</h2>\n<p>传统金融借贷依赖中心化机构进行信用评估与资金撮合，存在门槛高、透明度低、跨境结算成本高等问题。DeFi 借贷协议通过智能合约自动匹配供需双方，以超额抵押与清算机制保障系统偿付能力，已成为 Web3 基础设施的重要组成部分。</p>\n<p>本借贷池模块的定位为：</p>\n<ul>\n  <li><strong>链上货币市场入口：</strong>聚合多链、多协议借贷池数据，为用户提供统一的存贷信息视图；</li>\n  <li><strong>程序化收益分配：</strong>依据授权资产余额与市场 APY，按固定周期自动结算收益；</li>\n  <li><strong>透明可验证：</strong>池子 TVL、APY、利用率、LTV 等指标可溯源至公开链上数据；</li>\n  <li><strong>非托管原则：</strong>用户资产授权与链上交互由用户钱包发起，平台不持有用户私钥。</li>\n</ul>\n\n<h2>三、系统架构</h2>\n<h3>3.1 架构概览</h3>\n<p>系统采用分层架构设计，主要包含以下组件：</p>\n<ul>\n  <li><strong>用户交互层：</strong>Web / 移动端界面，支持钱包连接、资产授权、池子浏览、收益查询；</li>\n  <li><strong>业务服务层：</strong>用户鉴权、授权状态管理、收益订单生成与查询、多语言内容展示；</li>\n  <li><strong>数据聚合层：</strong>对接 DeFi 数据聚合 API 及协议 GraphQL 接口，定时同步借贷池指标；</li>\n  <li><strong>链上协议层：</strong>基于经审计的开源借贷协议智能合约，执行实际的存借逻辑。</li>\n</ul>\n\n<h3>3.2 核心数据指标</h3>\n<table>\n  <thead>\n    <tr><th>指标</th><th>说明</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL（总锁仓价值）</td><td>池内资产以美元计价的总量，反映市场深度</td></tr>\n    <tr><td>Supply APY（存款年化）</td><td>由基础利率与协议奖励叠加构成，随利用率动态浮动</td></tr>\n    <tr><td>Borrow APY（借款年化）</td><td>借款人需支付的年化成本，与资金利用率正相关</td></tr>\n    <tr><td>Utilization Rate（利用率）</td><td>已借出资金占可借资金的比例，影响利率曲线</td></tr>\n    <tr><td>Max LTV（最高贷款价值比）</td><td>抵押品可支撑的最大借款比例，超额部分触发清算</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>单资产供给与借款上限，用于控制集中度风险</td></tr>\n    <tr><td>Available Liquidity</td><td>当前可即时借出的流动性规模</td></tr>\n  </tbody>\n</table>\n\n<h3>3.3 数据同步机制</h3>\n<p>借贷池市场数据通过定时任务从公开数据源拉取，写入本地缓存与历史快照，用于前端展示、历史曲线及运营监控。每次同步记录时间戳，确保数据可追溯。</p>\n\n<h2>四、用户流程与收益机制</h2>\n<h3>4.1 参与流程</h3>\n<ol>\n  <li><strong>连接钱包：</strong>用户通过 Web3 钱包完成身份绑定；</li>\n  <li><strong>资产授权：</strong>对 USDT、USDC 等支持资产执行链上 Approve 授权；</li>\n  <li><strong>加入借贷池：</strong>系统根据授权状态将用户纳入对应池子的收益计算队列；</li>\n  <li><strong>收益结算：</strong>按固定周期（每日）依据授权余额与市场利率生成结算订单；</li>\n  <li><strong>资产查询：</strong>用户可在「个人资产」页查看授权余额、累计收益及历史结算明细。</li>\n</ol>\n\n<h3>4.2 利率模型</h3>\n<p>存款利率（Supply APY）由基础 APY 与奖励 APY 两部分组成，实际到账收益受授权余额、市场 APY 波动、结算周期及链上 Gas 等因素影响。<strong>历史 APY 不代表未来收益。</strong></p>\n\n<h3>4.3 费用说明</h3>\n<h4>DeFi 赚币如何收费？</h4>\n<p>链上交易需支付 gas 费用，以完成与智能合约的交互操作，包括认购和领取收益。对于部分资产，DeFi 借贷池与金库管理方将根据您实际获得的利润收取一定比例的业绩费，本金不受影响。</p>\n\n<h2>五、安全设计</h2>\n<ul>\n  <li>底层借贷协议采用经多家安全机构审计的开源合约，核心逻辑链上执行；</li>\n  <li>非托管架构，平台不存储用户私钥或助记词；</li>\n  <li>仅请求业务所需的 Token Approve 权限，用户可随时在钱包中撤销；</li>\n  <li>接口鉴权、HTTPS 传输、后台 RBAC 权限隔离与操作审计。</li>\n</ul>\n\n<h2>六、安全评估摘要</h2>\n<table>\n  <thead>\n    <tr><th>评估项</th><th>结论</th><th>说明</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>智能合约依赖</td><td><strong>通过</strong></td><td>采用经公开审计的 DeFi 协议合约</td></tr>\n    <tr><td>非托管与密钥管理</td><td><strong>通过</strong></td><td>无私钥存储，授权由用户钱包本地签名</td></tr>\n    <tr><td>API 与鉴权安全</td><td><strong>通过</strong></td><td>接口鉴权与 HTTPS 已落实</td></tr>\n    <tr><td>数据同步与一致性</td><td><strong>通过</strong></td><td>定时同步 + 快照机制，数据可溯源</td></tr>\n    <tr><td>收益结算逻辑</td><td><strong>通过</strong></td><td>周期结算规则明确，订单可追溯</td></tr>\n  </tbody>\n</table>\n<p><strong>总体评估结论：</strong>在现有架构与运维规范下，核心安全控制措施有效。用户仍须自行评估 DeFi 协议层风险，并妥善保管钱包私钥。</p>\n\n<h2>七、风险披露</h2>\n<ul>\n  <li><strong>智能合约风险：</strong>尽管经审计，合约仍可能存在未被发现的漏洞；</li>\n  <li><strong>市场风险：</strong>APY 随利用率与治理提案波动，可能出现大幅变化；</li>\n  <li><strong>清算风险：</strong>抵押品价格剧烈下跌可能触发清算；</li>\n  <li><strong>稳定币脱锚风险：</strong>USDT、USDC 等在极端条件下可能偏离锚定价格；</li>\n  <li><strong>监管政策风险：</strong>各国对 DeFi 的监管政策仍在演进。</li>\n</ul>\n<p><strong>本模块不提供投资建议，也不保证任何固定收益。</strong></p>\n\n<h2>八、术语表</h2>\n<ul>\n  <li><strong>APY：</strong>年化收益率；</li>\n  <li><strong>TVL：</strong>总锁仓价值；</li>\n  <li><strong>LTV：</strong>贷款价值比；</li>\n  <li><strong>Approve：</strong>ERC-20 代币授权；</li>\n  <li><strong>清算（Liquidation）：</strong>抵押品不足时自动出售抵押品以偿还债务。</li>\n</ul>\n\n<p>— 本文档仅供信息参考，不构成法律、财务或投资建议。链上数据以区块浏览器及协议官方接口为准。</p>',
    yieldLadder:
      '<p><strong>Defi Lending Pool</strong> 为已授权的稳定币资产提供透明、分档的每日收益计划。您的日收益由链上授权余额（USD 等值）及下方对应档位的日化收益率决定。档位利率由平台配置实时读取并展示。</p>\n\n<h2>一、收益机制说明</h2>\n<p>当您在 <strong>Defi Lending Pool</strong> 通过 Web3 钱包完成 USDT 或 USDC 链上授权后，系统将以您的链上授权可用余额作为计息基础。每个自然日，平台依据以下规则生成结算订单（USDT 与 USDC 分别计息、分别累计）：</p>\n<ul>\n  <li><strong>链上本金：</strong>结算时刻的授权稳定币余额（USD 等值）；</li>\n  <li><strong>档位利率：</strong>根据链上本金所在区间，匹配下方收益阶梯表中的基准日化收益率；</li>\n  <li><strong>复利模式（默认）：</strong>日收益 ≈（链上授权余额 + 该币种累计未提现收益）× 日化收益率 ÷ 100；</li>\n  <li><strong>单利模式（如平台开启）：</strong>日收益 ≈ 链上授权余额 × 日化收益率 ÷ 100。</li>\n</ul>\n<p>平台收益提现仅影响账户可提现余额及复利累计基数，<strong>不影响链上钱包余额</strong>。结算频率为<strong>每日四次</strong>，收益累计计入账户，可在「资产 → 结算订单」中查看明细。历史收益不代表未来表现。</p>\n\n<h2>二、收益阶梯表</h2>\n<p>下表展示 <strong>Defi Lending Pool</strong> 当前生效的授权余额档位与对应日化收益率。授权余额越高，可匹配的档位利率通常越高。表中利率均为<strong>日化百分比</strong>，非年化 APY。</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>说明：</strong>系统在每个结算日自动根据您的<strong>链上授权余额</strong>匹配对应档位。若链上余额变动导致区间变化，下一结算日将按新档位利率执行。复利模式下，累计未提现收益参与计息但不改变档位匹配。</p>\n\n<h2>三、档位匹配规则</h2>\n<ul>\n  <li>仅<strong>已完成链上授权（Approve）</strong>的 USDT / USDC 余额参与计息；</li>\n  <li>低于最低档位门槛的余额不参与结算；</li>\n  <li>每个档位对应一个 USD 余额区间，系统自动匹配唯一适用档位；</li>\n  <li>若某档位配置为区间利率，则按最小与最大日化利率的平均值（(最小+最大)÷2）结算；</li>\n  <li>档位配置可由平台运营方调整，变更仅对后续结算生效，不影响历史订单。</li>\n</ul>\n\n<h2>四、结算与展示</h2>\n<h3>4.1 结算周期</h3>\n<ul>\n  <li><strong>结算频率：</strong>每个已授权资产每日结算四次；</li>\n  <li><strong>首次结算：</strong>当日完成授权的钱包，从次日起开始计息结算；</li>\n  <li><strong>订单字段：</strong>结算金额、币种（USDT / USDC）、适用利率、结算时间。</li>\n</ul>\n<h3>4.2 资产页指标</h3>\n<p>在「资产」页可查看<strong>累计收益</strong>（历史结算总和）与<strong>今日收益</strong>（当日已结算部分），数据以系统订单记录为准。</p>\n\n<h2>五、如何在 Defi Lending Pool 开始获取收益</h2>\n<ol>\n  <li>登录账户并连接 Web3 钱包（MetaMask 或兼容钱包）；</li>\n  <li>在侧栏点击「立即加入」，选择 USDT 或 USDC；</li>\n  <li>在钱包中确认链上 <strong>Approve（授权）</strong> 交易；</li>\n  <li>授权成功后，系统将自动按余额匹配收益档位；</li>\n  <li>在「资产」页查看每日结算订单与累计收益。</li>\n</ol>\n\n<h2>六、风险提示</h2>\n<p><strong>Defi Lending Pool</strong> 采用非托管模式，平台不保管用户私钥。链上授权存在智能合约及市场风险，档位利率、池容量与结算结果可能发生变化。参与前请仔细阅读「规则与安全」页面。</p>\n\n<p>— 档位利率数据同步自平台后端配置，页面展示仅供参考；最终结算金额以每日订单记录为准。</p>',
  },
  lendingDetail: {
    assetOn: '资产所在链',
    availableLiquidity: '可用流动性',
    avgApy30d: '30日均 APY',
    baseApy: '基础 APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowApy: '借款 APY',
    borrowCapacity: '借款容量',
    borrowCapacityFilled: '借款容量使用',
    borrowDesc: '使用已存抵押品借入 {symbol}',
    borrowHint: '借款协议',
    borrowMarkets: '借款市场',
    borrowSoon: '链上借款功能即将开放',
    borrowingEnabled: '可借款',
    capacityFilled: '容量使用',
    chain: '所属链',
    chains: '链数量',
    collateral: '抵押品',
    deposit: 'Deposit',
    depositApy: '存款 APY',
    depositCapacity: '存款容量',
    depositDesc: '存入 {symbol} 以获取收益',
    depositMarkets: '存款市场',
    depositSoon: '链上存款功能即将开放',
    eligible: '可用作抵押',
    exposure: '风险敞口',
    loading: '加载中...',
    maxLtv: '最高 LTV',
    no: '否',
    notEligible: '不可用作抵押',
    notFound: '未找到该借贷池',
    period: '周期',
    poolCount: '借贷池数量',
    price: '价格',
    protocol: '协议',
    remainingCapacity: '剩余容量',
    rewardApy: '奖励 APY',
    stablecoin: '稳定币',
    stablecoinPrice: '约 $1.00',
    subscribe: '认购',
    subscribed: '已认购',
    title: '借贷池详情',
    totalBorrows: '总借款',
    totalDeposits: '总存款',
    totalPoolDepositDesc: '存入 USDT/USDC 以获取收益',
    utilization: '资金利用率',
    yes: '是',
    yieldRate: '收益率',
  },
  lendingIdentity: {
    needLogin: '请先登录后再进行实名认证',
    needVerifyHint: '请先完成实名认证后再加入借贷池',
    pageDesc: '完成实名认证后即可加入借贷池，享受存贷服务',
    pendingHint: '您的实名认证正在审核中，请耐心等待',
  },
  lendingMenu: {
    assets: '资产',
    chooseDepositAsset: '选择存入资产',
    chooseDepositHint: '将资产存入借贷池以获取收益，并支持后续借款',
    copyUid: '复制 UID',
    customerService: '在线客服',
    depositAssetAction: '存入 {symbol}',
    earnings: '盈利方式',
    empty: '暂无内容',
    explore: '探索',
    footerDesc:
      '依托开源智能合约搭建的新一代链上货币市场，以程序化规则代替人工管控，为全球Web3用户提供安全透明的流动性存贷服务。',
    getStarted: '立即加入',
    home: '首页',
    identityVerification: '实名认证',
    intro: '简介',
    language: '语言',
    noAssetPool: '暂未找到该资产的借贷池',
    rulesSecurity: '规则与安全',
    security: '安全性',
    theme: '外观',
    uid: 'UID',
    whitepaper: '平台白皮书',
    yieldLadder: '收益阶梯',
  },
  lendingTheme: {
    auto: '跟随系统',
    dark: '深色',
    light: '浅色',
    title: '外观',
  },
  lendingYieldLadder: {
    balance: '单笔借出本金（USDT）',
    compoundInterest: '复利',
    earningMode: '收益展示方式：{mode}',
    empty: '暂无档位配置',
    loading: '正在加载档位利率…',
    noteFixed: '每日按该档位固定日化利率结算',
    noteRange: '每日按该档位区间上限结算',
    notes: '说明',
    rate: '日化收益率区间',
    settlementHours: '配置结算时点：{hours}',
    simpleInterest: '单利',
  },
  liangCiMiMaBuYiZhi: '两次密码不一致',
  loan: {
    Browse: '浏览',
    address: '地址：',
    birthdate: '出生日期：',
    borrow: '借款',
    borrowNow: '立即借款',
    borrowPlaceholder: '我想借...',
    browse: '浏览',
    checkIn: '提交完成',
    confirm: '确认',
    continue: '继续',
    country: '国家：',
    dailyRate: '日利率',
    days: '天',
    document: '证件：',
    done: '完成！',
    driverLicense: '驾驶证',
    dropHere: '将图片拖放到此处',
    ensure: '确定',
    female: '女',
    firstName: '名字：',
    idCard: '身份证',
    inHand: '进行拍照',
    lastName: '姓氏：',
    launchCamera: '启动相机',
    loanAgreement: '贷款协议',
    loanAmount: '贷款金额',
    loanAmountRangeError: '贷款金额必须在 {min} - {max} USD 范围内',
    loanAmountTooHigh: '贷款金额不能超过 {max} USD',
    loanAmountTooLow: '贷款金额不能低于 {min} USD',
    loanDetail: '贷款详情',
    loanTerm: '贷款期限',
    male: '男',
    notVerifyBtn: '开始验证',
    notVerifyTip: '验证您的身份，获得更多贷款额度！',
    or: '或',
    passport: '护照',
    pendingReview: '审核中',
    phone: '电话号码：',
    phonePlaceholder: '输入您的电话号码...',
    reSign: '重新签署',
    resubmit: '重新提交',
    sex: '女性/男性：',
    sign: '签署',
    signTip: '请确认并签署',
    signed: '已签署',
    startVerfication: '开始验证',
    submit: '提交',
    supports: '支持：JPG, JPEG2000, PNG',
    takePhoto: '拍照',
    term: '贷款期限（天）',
    tipIdCardBack: '将身份证背面置于框内',
    tipIdCardFront: '将身份证正面置于框内',
    tipNotPass:
      '很抱歉，您的KYC申请未通过验证过程。请重新提交正确的申请材料以完成KYC验证。如果您有任何疑问或需要帮助，请随时联系我们的客户服务团队。',
    tipTakePhoto: '请手持您的',
    tipVerifiedSuccess: '恭喜！您的KYC申请已通过验证，您现在可以享受更高级别的服务。',
    tipWaitForResult:
      '感谢您提交KYC认证资料。我们的团队将在48小时内对您的资料进行审核，请耐心等待！',
    title: '贷款',
    totalAmount: '总利息金额',
    verifiedSuccessfully: '验证成功',
    verifiedUnsuccessfully: '验证失败',
    verifyBtn: '验证成功',
    verifyTip: '获得即时资金来保障您的投资！',
  },
  login: {
    btnContinueFacebook: '继续使用Facebook',
    btnContinueGoogle: '继续使用谷歌',
    btnLogin: '登录',
    btnLoginFacebook: '使用Facebook登录',
    btnLoginGoogle: '使用谷歌登录',
    btnNext: '下一步',
    btnRecovery: '找回',
    btnRecoveryPsd: '找回密码',
    btnRegister: '注册',
    btnRegisterFacebook: '使用Facebook注册',
    btnRegisterGoogle: '使用谷歌注册',
    btnSend: '发送',
    btnSignup: '注册',
    emailPlaceholder: '请输入邮箱，如 name@example.com',
    emailTips: '该邮箱已被注册',
    hasAccount: '已经有帐户？',
    hasNotAccount: '还没有帐户？',
    inputCode: '请输入验证码',
    inputEmail: '请输入邮箱',
    inputPassword: '请输入密码',
    inputPhone: '请输入邮箱',
    inputUsernameOrEmail: '请输入用户名或邮箱',
    labelEmail: '邮箱：',
    labelEmailCode: '验证码:',
    labelPsd: '密码：',
    labelPsdNew: '新密码：',
    labelPsdRepeat: '确认密码：',
    labelUsername: '用户名：',
    labelUsernameOrEmail: '用户名或邮箱：',
    phoneTips: '该邮箱已被注册',
    starLogin: '让我们从登录开始！',
    starRegist: '让我们从注册开始！',
    starReset: '通过邮箱找回密码！',
    tipRegisterContent:
      '完成您的注册并打开通往令人兴奋的投资机会世界的大门，为财务成功和增长铺平道路！',
    tipRegisterTitle: '注册并开始您的繁荣投资之旅！',
    useEmailRegister: '使用邮箱注册',
    usePhoneRegister: '使用手机号注册',
    username: '用户名',
    usernameOptional: '用户名（可选，不填则与邮箱相同）',
    usernameTips: '该用户名已存在！',
    welcome: '欢迎来到',
  },
  navBottom: {
    bottomCompany: '公司',
    bottomCompanyItem1: '关于我们',
    bottomCompanyItem2: '牌照监管',
    bottomCompanyItem3: '常见问题',
    bottomCompanyItem4: '在线支持',
    bottomOther: '声明',
    bottomOtherItem1: '法律信息',
    bottomOtherItem2: '免责声明',
    bottomOtherItem3: '风险提示',
    bottomOtherItem4: 'Cookie政策',
    bottomOtherItem5: '关于广告',
    bottomPolicy: '政策',
    bottomPolicyItem1: '条款条件',
    bottomPolicyItem2: '隐私政策',
    bottomProduct: '产品',
    bottomProductItem1: '市场列表',
    bottomProductItem2: '投资借贷',
    bottomProductItem3: '公益NFT',
    bottomProductItem4: '智能交易',
  },
  navTab: {
    btnLogin: '登录',
    btnSignup: '注册',
    language: '语言',
    languageTips: '选择语言和地区',
    tabMenu1: '首页',
    tabMenu2: '市场',
    tabMenu3: '智能交易',
    tabMenu4: '贷款',
    tabMenu5: '理财',
    tabMenu6: 'NFTs',
    tabMenu7: '账户',
  },
  nfts: {
    buy: '购买',
    buyFeatureComingSoon: '购买功能即将上线',
    charityProjects: '慈善项目',
    collection: 'NFT收藏',
    completed: '已完成',
    confirmDonate: '确认捐赠',
    donate: '捐赠',
    donateAmount: '捐赠金额',
    donateSuccess: '捐赠成功，感谢您的爱心！',
    donateToProject: '为项目捐赠',
    donors: '捐赠人数',
    enterAmount: '请输入金额',
    pleaseEnterValidAmount: '请输入有效的捐赠金额',
    raised: '已筹集',
    status: {
      active: '进行中',
      completed: '已完成',
    },
    subtitle: '通过区块链技术，让慈善更透明',
    target: '目标金额',
    title: 'NFTs慈善',
    viewDetails: '查看详情',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: '您输入的止损价格不合理',
  ninShuRuDeZhiYingJiaGeBuHeLi: '您输入的止盈价格不合理',
  notifications: {
    deposit: {
      content:
        '尊敬的用户，我们已收到您\u0024{amount}美元的存款，并已成功将\u0024{amount}添加到您的账户余额中。',
      title: '存款通知',
    },
    kyc: {
      content: '尊敬的用户，恭喜您通过了KYC验证。您现已完成KYC流程，可以享受更高级别的服务。',
      title: 'KYC验证通过',
    },
    loan: {
      content:
        '尊敬的客户，恭喜您，您的贷款申请已获批准，金额为\u0024{amount}美元。我们已审核并通过了您的申请，贷款金额已存入您的账户。请登录您的账户查看详细信息。',
      title: '贷款已批准',
    },
    repayment: {
      content: '尊敬的用户，我们已成功收到您\u0024{amount}美元的还款。感谢您一直以来的支持。',
      title: '还款成功',
    },
    withdraw: {
      content: '尊敬的用户，您申请的\u0024{amount}美元提现已成功处理。请留意相关信息并及时查收。',
      failed: {
        content:
          '尊敬的用户，您的\u0024{amount}元提现请求失败。请仔细检查提现信息，并及时联系在线客服。',
        title: '提现通知',
      },
      title: '提现通知',
    },
  },
  ntfs: {
    Address: '地址',
    AllMoneyCharities: 'NFTs销售所得的全部款项将捐赠给联合国儿童基金会慈善机构',
    BuyNFT: '购买NFT艺术品，帮助世界各地的儿童！',
    BuyNow: '立即购买',
    Chain: '所属链',
    Confirm: '确认',
    Creator: '创作者',
    CumulativeDonation: '累计捐款',
    CurrentBid: '当前出价',
    Markets: '市场',
    MyNFTs: '我的NFTs',
    NFTs: 'NFTs',
    NFTsDetail: 'NFTs详情',
    PlaceABid: '竞拍',
    RemainingTime: '剩余时间',
    Successful: '成功',
    ThanksDonation: '感谢您的捐赠',
    Thisaddress: '该物品将发送至您的钱包地址',
    Verified: '已验证',
    andUNICEF: '捐款将捐赠给联合国儿童基金会',
    charity: '慈善',
  },
  null: '未知错误',
  permission_denied: '没有权限，请联系管理员授权',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: '请切换为真实账户操作',
  qingShangChuanPingZheng: '请上传凭证',
  qingShuRuDiZhi: '请输入地址',
  qingShuRuShouJiHao: '请输入邮箱',
  qingShuRuShuLiang: '请输入交易数量',
  qingShuRuTouZiJinE: '请输入投资金额',
  qingShuRuYanZhengMa: '请输入验证码',
  qingShuRuZhengQueDeJinE: '请输入正确的金额',
  qingShuRuZhengQueDeYouXiang: '请输入正确的邮箱',
  qingShuRuZhiSunJiaGe: '请输入止损价格',
  qingShuRuZhiYingJiaGe: '请输入止盈价格',
  qingTianXieWanZhengXinXi: '请填写完整信息',
  qingZaiCiShuRuMiMa: '请再次输入密码',
  queRenMiMa: '确认密码',
  repayApplicationPending: '还款申请审核中',
  repayApplicationRejected: '还款申请被拒绝',
  repayApplicationSubmitted: '还款申请已提交，请等待管理员审核',
  repaySuccess: '还款成功',
  return: '结算时间',
  ri: '日',
  riLiShuai: '日利率:',
  search: {
    SearchHere: '搜索',
  },
  shangChuanShiBaiQingZhongShi: '上传失败，请重试',
  shenHeBuTongGuo: '审核不通过',
  shou: '收',
  shouJiHao: '邮箱',
  shouXuFeiShiJiDaoZhangJinE: '手续费/实际到账金额',
  shouYiZhong: '收益中',
  shouYiZhuangTai: '收益状态',
  shuRuNinDeDianHuaHaoMa: '输入您的电话号码...',
  souSuo: '搜索...',
  spotCloseSuccess: '现货卖出成功',
  spotOrderSuccess: '现货订单提交成功',
  staticIncome: '钱包收益',
  tiJiaoChengGong: '提交成功',
  tiJiaoChongZhiPingZheng: '提交充值凭证',
  tiKuanFangShi: '提款方式',
  tiXian: '提现',
  tiXianDiZhi: '提现地址',
  tiXianShiJian: '提现时间',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    '提现需要 {rate}% 的手续费，需要网络节点确认后才能入账请不要将加密货币转给陌生人',
  toast: {
    UnreasonablePriceProfitLoss: '止盈止损价格设置不合理',
    buyNumbers: '请输入购买数量',
    copyError: '复制失败！',
    copySuccess: '复制成功！',
    email: '请输入您的邮箱',
    inputAll: '数据输入不完整',
    loading: '加载中...',
    logOut: '已登出',
    noData: '没有更多数据',
    notAddress: '请输入钱包地址',
    notAmount: '请输入金额',
    notEmail: '邮箱格式不正确',
    notImage: '图片格式不正确',
    notLoanAmount: '请输入贷款金额',
    notSigned: '未签名',
    notSmartAmount: '请输入理财金额',
    notSupportMedia: '不支持获取用户媒体',
    notVerify: '请先完成KYC认证',
    notWithdrawAmount: '请输入取款金额',
    nothingfound: '暂时没有找到内容！',
    password: '请输入密码',
    passwordNotSame: '密码输入不一致',
    passwordRepeat: '请确认您的密码',
    uploadImage: '请上传所需图片',
    userName: '请输入用户名',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    '通常，需要您的邮箱、用户名、密码等基本信息，有时还需要个人信息和联系信息。',
  touZiShiJian: '投资时间',
  touZiZhouQi: '投资周期',
  tuPianDaXiaoBuNengChaoGuo_2mb: '图片大小不能超过 2MB!',
  tuPianDaXiaoBuNengChaoGuo_5m: '图片大小不能超过50MB!',
  uploadfailed: 'uploadFailed',
  usdtZuiDiChongZhiJinewei_120: '{name}最低充值金额为{limit}',
  vipLevel: {
    'Normal User': '普通用户',
    VIP1: 'VIP1',
    VIP2: 'VIP2',
    VIP3: 'VIP3',
    VIP4: 'VIP4',
  },
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    '外汇自动交易量化是一种利用计算机程序和算法自动执行交易策略的方法。 该方法使用历史数据、技术指标、统计模型和其他分析工具来识别交易信号，并在执行交易时自动执行这些信号。 外汇自动交易量化可以帮助交易者消除情绪影响，减少错误交易，提高交易效率和一致性。 但是，自动外汇交易量化也存在一些潜在的风险和局限性。 例如，自动交易程序可能无法适应市场变化，交易程序和算法的质量和有效性在很大程度上取决于历史数据的可靠性和有效性。 此外，自动交易还可能存在技术风险，如电脑故障、网络中断等，因此，在使用外汇自动交易量化前，投资者需要仔细评估自己的交易目标、风险承受能力和技术能力，选择可靠的交易平台。 交易平台和自动交易程序。 最重要的是，投资者应始终保持谨慎并采取适当的风险管理措施来保护他们的投资。',
  wallet: {
    activate: '激活',
    alreadyAuthorized: '{token} 已经授权',
    authFailed: '授权失败',
    authFailedRetry: '授权失败，请检查网络连接后重试',
    authSuccess: '授权成功',
    authSuccessWithReward: '{token} 授权成功！现在可以享受钱包收益了',
    authorizationFailed: '失败',
    authorizationSuccess: '成功',
    authorized: '已授权',
    authorizingToken: '正在授权 {token}，请在钱包中确认...',
    connectFailed: '连接钱包失败',
    connectWallet: '连接钱包',
    connecting: '连接中...',
    justCanWallet: '本网站仅接受去中心化Dapp的访问',
    networkNotSupported: '当前网络不支持，请切换到支持的网络',
    noWalletDetected: '未检测到钱包，请安装MetaMask或TronLink',
    pleaseConnectWallet: '请连接钱包',
    pleaseLoginFirst: '请先连接钱包登录',
    savingAuth: '正在保存授权信息，请稍候...',
    signatureLogin: {
      getNonceFailed: '获取随机数失败',
      loggingIn: '正在登录...',
      loginFailed: '登录失败',
      loginSuccess: '登录成功',
      signatureFailed: '签名失败，请重试',
      signing: '正在签名，请在钱包中确认...',
      userRejectedSignature: '您取消了签名操作',
      verificationFailed: '签名验证失败',
      walletNotInstalled: '未检测到钱包，请安装MetaMask或其他Web3钱包',
    },
    status: '钱包状态',
    testnetDisabled: '测试网络已禁用，请使用主网',
    transactionCancelled: '交易已取消',
    unauthorized: '未授权',
    userCancelled: '用户取消了操作',
    userCancelledAuth: '您取消了授权操作',
  },
  walletAllowanceInsufficient: '当前授权额度不足，需要重新授权',
  walletAllowanceQueryFailed: '查询当前授权失败',
  walletAllowanceSufficient: '当前授权额度已足够，无需重新授权',
  walletAlreadyApproved: '已经授权，无需重新授权',
  walletApproveResult: '授权成功',
  walletApproveSuccess: '新授权交易成功',
  walletConfigEmpty: '响应为空',
  walletConfigError: '初始化钱包配置失败',
  walletConfigFailed: '获取钱包配置失败',
  walletConfigLoadComplete: '配置加载完成',
  walletConfigLoaded: '钱包配置加载成功',
  walletConfigLoading: '开始执行代币授权',
  walletConfigNotLoaded: '未加载',
  walletConfigStatus: '当前配置状态',
  walletConnecting: '正在获取钱包配置...',
  walletConnectingTo: '正在连接',
  walletContractCallFailed: '合约调用预检失败，请检查合约地址和参数',
  walletContractFailed: '合约执行失败，请检查交易参数',
  walletContractInfoFailed: '合约基本信息查询失败，可能不是标准ERC20合约',
  walletContractInfoNormal: '合约基本信息正常',
  walletContractNotSupported: '代币合约不支持此操作',
  walletContractPaused: '代币合约已暂停或有其他限制',
  walletContractRejectAuth: '代币合约拒绝了授权操作，请检查合约是否支持标准ERC20授权',
  walletContractReverted: '合约执行被回滚，可能的原因',
  walletContractSpecialRules: '合约有特殊的授权规则',
  walletCurrentAllowance: '当前授权额度',
  walletDetecting: '自动检测到钱包',
  walletEthConnectFailed: '以太坊钱包连接失败',
  walletEthConnecting: '开始连接以太坊钱包...',
  walletGasEstimate: '预估Gas用量',
  walletGasEstimateFailed: 'Gas估算失败，交易可能会失败',
  walletGetTokenContract: '获取代币合约地址',
  walletInsufficientBalance: '账户余额不足，请确保有足够的ETH/TRX支付手续费',
  walletInsufficientGas: '交易费用不足，请调整Gas设置后重试',
  walletNetworkTimeout: '网络连接超时，请检查网络后重试',
  walletNoTokenWarning: '用户没有此代币，但仍可以进行授权',
  walletResetAllowance: '尝试先重置授权为0...',
  walletResetAllowanceFailed: '重置授权失败，继续尝试直接授权',
  walletResetAllowanceSuccess: '授权重置成功',
  walletSmartContractFailed: '获取智能合约地址失败',
  walletTokenApproveAmount: '授权数量',
  walletTokenApproveTo: '授权给',
  walletTokenApproving: '授权代币',
  walletTokenBalanceQueryFailed: '查询代币余额失败',
  walletTransactionFailed: '交易失败，请稍后重试',
  walletUserEthBalance: '用户ETH余额',
  walletUserRejected: '用户取消了交易授权',
  walletUserTokenBalance: '用户代币余额',
  walletUsingSmartContract: '使用智能合约地址作为授权目标',
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan: '网络超时,请去订单列表查看该订单',
  weiKaiQiZhiNengJiaoYi: '未开启智能交易',
  weiRenZheng: '未认证',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: '为什么我需要注册一个帐户？',
  weiTongGuo: '未通过',
  woDeZhuCeXinXiHuiBeiBaoMiMa: '我的注册信息会被保密吗？',
  woKeYiGengGaiWoDeZhuCeXinXiMa: '我可以更改我的注册信息吗？',
  woKeYiZhuCeDuoGeZhangHuMa: '我可以注册多个帐户吗？',
  xiaCiShouYiShiJian: '下次收益时间',
  xiaDanChengGong: '下单成功',
  xinGongNengShangXian: '新功能上线！',
  xinMiMa: '新密码',
  yanShiZhangHaoBuNengShiYongGaiGongNeng: '演示账号不能使用该功能',
  yanShiZhangHuBuNengChuangJianZhiNengJiaoYi: '交易失败：演示账户不能创建自动交易策略',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi: '演示账户不能使用智能交易',
  yanShiZhangHuYiJinYong: '演示账户已禁用',
  yiDaoQi: '已到期',
  yiFenRun: '已分润',
  yiFenRunTianShu: '已分润天数',
  yiHuanKuan: '已还款',
  yiJuJue: '已拒绝',
  yiQieHuanWeiXuNiZhangHu: '已切换为虚拟账户',
  yiQieHuanWeiZhenShiZhangHu: '已切换为真实账户',
  yiRenZheng: '已认证',
  yiWanCheng: '已完成',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    '一些网站可能允许用户注册多个账户，但大多数网站只允许每个用户注册一个账户。 如果您尝试注册多个帐户，您的帐户可能会被禁止或删除。',
  zhangFu: '涨幅',
  zhenFu: '振幅',
  zhuCeChengGong: '注册成功',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    '注册帐户可以让您更方便地使用网站或应用程序的功能，并可以保护您的个人信息。',
  zhuCeZhangHuXuYaoShiMoXinXi: '注册账户需要什么信息？',
  zongLiXi: '总利息',
  zuiDiJia: '最底价',
}
